"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
const parties = [{
  title: "AVS",
  description: "Sosteniamo Borelli per una Albano inclusiva, solidale e attenta ai bisogni di ogni cittadino.",
  logo: "https://borellisindaco.it/wp-content/uploads/2026/05/Alleanza-Verdi-Sinistra-Albano10cm@2x.png?v=zo7hmq9542",
  path: "/ListOneDemocraticPartyPage"
}, {
  title: "PARTITO DEMOCRATICO",
  description: "La nostra priorità è la tutela del verde pubblico e la mobilità dolce per una città più sana.",
  logo: "https://borellisindaco.it/wp-content/uploads/2026/05/pd.png?v=x3qyuu6oiwn",
  path: "/ItalianLeftListPage"
}, {
  title: "M5S",
  description: "Ecologia e sostenibilità al centro dell'azione amministrativa per il futuro di Albano.",
  logo: "https://borellisindaco.it/wp-content/uploads/2026/05/mov.png?v=6pbmijyy465",
  path: "/ListGreenEuropePage"
}, {
  title: "CASA RIFORMISTA",
  description: "Competenza e pragmatismo per un'amministrazione efficiente e vicina alle imprese.",
  logo: "https://borellisindaco.it/wp-content/uploads/2026/05/casa-r.png?v=0nf8rizxuzke",
  path: "/CasaRiformistaCopyPage"
}, {
  title: "PASSIONE CIVICA",
  description: "Diritti, libertà e una visione europea per lo sviluppo del nostro territorio.",
  logo: "https://borellisindaco.it/wp-content/uploads/2026/05/WhatsApp-Image-2026-03-26-at-17.09.12-1.png?v=jtqzer4q75",
  path: "/PassioneCivicaCopyPage"
}, {
  title: "IDENTITA BENE COMUNE",
  description: "Cittadini al servizio della città per dare continuità al buon governo e ai progetti avviati.",
  logo: "https://borellisindaco.it/wp-content/uploads/2026/05/274695593_262210502757943_2291766898422543541_n.png?v=owbob2kmoqm",
  path: "/ListCivicsPage"
}];
export default function CoreOfferings() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="240829" id="le-liste" className="bg-background text-foreground py-24 px-6 md:px-8 lg:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`max-w-2xl mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight mb-4 text-primary">
            La Coalizione
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-default">
            Sei liste unite per sostenere la candidatura di Borelli Sindaco. Una squadra competente per Albano Laziale.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12 md:gap-16">
          {parties.map((party, i) => {
          const {
            ref: partyRef,
            isVisible: isPartyVisible
          } = useRevealOnScroll({
            threshold: 0.1
          });
          return <div key={i} data-index={i} ref={partyRef} className={`transition-all duration-700 ease-out flex flex-col items-center text-center`} style={{
            opacity: isPartyVisible ? 1 : 0,
            transform: isPartyVisible ? "translateY(0)" : "translateY(24px)",
            transitionDelay: `${i * 100}ms`
          }}>
                <Link to={party.path} className="group flex flex-col items-center">
                  <div className="relative w-32 h-32 md:w-40 md:h-40 mb-6 rounded-full overflow-hidden border-2 border-border group-hover:border-primary group-hover:scale-110 group-hover:shadow-xl transition-all duration-300 bg-white flex items-center justify-center p-2">
                    <img src={party.logo} data-wvc-srcset={`${party.logo}-wvc-srcset`} data-wvc-sizes={`${party.logo}-wvc-sizes`} alt={party.title} className="w-full h-full object-contain" loading="lazy" />
                  </div>
                  
                  <h3 className="font-default text-xl font-bold mb-3 text-primary group-hover:text-secondary transition-colors duration-300">
                    {party.title}
                  </h3>
                  
                  <p className="text-muted-foreground font-default leading-relaxed max-w-xs">
                    {party.description}
                  </p>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}